const Spinner = () => {
    return(
    <div>
        <div className="center-spin"><div className="lds-ring"><div></div><div></div><div></div><div></div></div></div>
    </div>)
}

export default Spinner